import * as Flags from "country-flag-icons/react/3x2";

import { cn } from "@tudigo-monorepo/core-tudigo-theme";

export const CountryFlag = ({
  countryCode,
  className,
}: {
  countryCode: string; // Only uppercase country code "FR", "US" etc
  className?: string;
}) => {
  const Flag = Flags[countryCode.toUpperCase() as keyof typeof Flags];

  return <Flag className={cn("h-2.5 w-4", className)} />;
};
